module.exports = __webpack_public_path__ + "assets/images/pdf/PI/0015.jpg";